// ts-rest contract for the Comply > Regulatory Calendar surface.
//
// Phase 4 of /api/db/:table removal (OLD_CODE.html #1). Replaces the page's
// useTable<RegulatoryReturn>('regulatory_returns') + the named-action
// `mark-reg-return-submitted` dispatch with a typed read + a typed POST.
// Controller gates the staff-persona ACL (comply / admin / view).

import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const regulatoryReturnStatusSchema = z.enum([
    'Not Started',
    'In Progress',
    'Under Review',
    'Submitted',
    'Auto-submitted',
]);
export type RegulatoryReturnStatusDto = z.infer<typeof regulatoryReturnStatusSchema>;

export const regulatoryReturnSchema = z.object({
    id: z.string(),
    name: z.string(),
    authority: z.string(),
    period: z.string(),
    dueDate: z.string(),
    status: regulatoryReturnStatusSchema,
    preparer: z.string(),
    reviewer: z.string(),
});
export type RegulatoryReturnDto = z.infer<typeof regulatoryReturnSchema>;

export const regCalendarResponseSchema = z.object({
    returns: z.array(regulatoryReturnSchema),
});
export type RegCalendarResponse = z.infer<typeof regCalendarResponseSchema>;

import { errorBody } from '../schemas/common';

export const complyRegCalendarContract = c.router(
    {
        list: {
            method: 'GET',
            path: '/comply/reg-calendar',
            responses: { 200: regCalendarResponseSchema, 403: errorBody },
            summary: 'List regulatory returns the Comply calendar surfaces',
        },
        markSubmitted: {
            method: 'POST',
            path: '/comply/reg-returns/:id/mark-submitted',
            pathParams: z.object({ id: z.string() }),
            body: z.object({}).optional(),
            responses: {
                200: z.object({ returnRow: regulatoryReturnSchema }),
                403: errorBody,
                404: errorBody,
            },
            summary: 'Mark a regulatory return as submitted',
        },
    },
    { pathPrefix: '/api', strictStatusCodes: false },
);
